/**
 * Created with JetBrains WebStorm.
 * User: bastienrobinot
 * Date: 04/01/18
 * Time: 16:50
 * To change this template use File | Settings | File Templates.
 */

angular.module('FlexyBeautyApp.services').
factory('Currency_Resource',["$resource","$location",
    function ($resource,$location)
    {
        var baseUrl = $location.protocol() + "://" + $location.host() + ($location.port() && ":" + $location.port())  + "/";
        return  $resource( baseUrl + 'rest/currencys/:id' , {} ,
            {
                query: { method: 'GET', isArray: true },
                get: { method: 'GET' },
                save  : { method: 'POST', url: baseUrl+'rest/currencys/'},
            }
        );
    }
]);

angular.module('FlexyBeautyApp.services').
factory('Currency',["Currency_Resource","CurrencyData",
    function (Currency_Resource,CurrencyData)
    {
        var Currency = function (resource)
        {
            this.id = null;
            this.code = false;
            this.name = null;
            this.symbol = null;
            this.codeMango = null;
            this.isPaymentAccepted = null;
            this.typeBankAccount = null;
            if(resource !== undefined && resource !== null)
                this.loadObject(resource);

            CurrencyData.add(this);
        };

        Currency.prototype.setId = function(id)
        {
            this.id = id;
        };
        Currency.prototype.getId = function()
        {
            return this.id;
        };

        Currency.prototype.loadObject = function(object)
        {
            if (object)
            {
                if (!this.id)
                    this.id = object.id;
                this.isDeleted = object.isDeleted;
                this.name = object.name;
                this.code = object.code;
                this.symbol = object.symbol;
                this.codeMango = object.codeMango;
                this.isPaymentAccepted = object.isPaymentAccepted;
                this.typeBankAccount = object.typeBankAccount;
            }
        };


        Currency.prototype.getObjectResource = function(object)
        {
            var newApp = new Currency_Resource();

            newApp.id = this.id;
            newApp.isDeleted = this.isDeleted;
            newApp.name = this.name;
            newApp.code = this.code;
            newApp.symbol = this.symbol;
            newApp.codeMango = this.codeMango;
            newApp.isPaymentAccepted = this.isPaymentAccepted;
            newApp.typeBankAccount = this.typeBankAccount;

            return newApp;
        }

        return Currency;
    }
]);

angular.module('FlexyBeautyApp.services').
factory('CurrencySrv',["$log","ServerSrv","Currency_Resource","CurrencyData","Currency",
    function ($log,ServerSrv,Currency_Resource,CurrencyData,Currency)
    {
        var currencySrv = {};

        currencySrv.query = function(successFunction,errorFunction)
        {
            Currency_Resource.query(
                {}, //params
                function (data) {

                    CurrencyData.clear();
                    for(var i=0;i<data.length;i++)
                    {
                        new Currency(data[i]);
                    }

                    if (successFunction!== undefined)
                        successFunction();
                },
                function (data) {
                    if (errorFunction !== undefined)
                        errorFunction(data);
                }
            );
        };
        currencySrv.restore = function(currency,successFunction,errorFunction)
        {
            CurrencyData.restore(currency);
            ServerSrv.startSavingProcess(currencySrv.restoreSync, currency, successFunction, errorFunction);
        };
        currencySrv.restoreSync = function(currency,successFunction,errorFunction)
        {
            //$timeout (function () {

            var CurrencyRes = currency.getObjectResource();
            CurrencyRes.$save({}, //no params
                function (data) {
                    //Save on server success :
                    // -> set id for new entity
                    // -> add an user action (send message)
                    try{
                        currency.setId(data.id);
                        if (successFunction !=undefined)
                            successFunction(data);
                    }
                    finally {
                        ServerSrv.endSavingProcess(true);
                    }
                },
                function (data) {   //failure
                    //error handling goes here
                    try {
                        if (errorFunction != undefined)
                            errorFunction(data);
                    }
                    finally {
                        ServerSrv.endSavingProcess(false,(data?data.status:null),(data && data.data?data.data.errorCode:null));
                    }
                }
            );

            //},2000)
        };
        currencySrv.save = function(currency,successFunction,errorFunction)
        {
            ServerSrv.startSavingProcess(currencySrv.saveSync, currency, successFunction, errorFunction);
        };
        currencySrv.saveSync = function(currency,successFunction,errorFunction)
        {
            //$timeout (function () {

            var currencyRes = currency.getObjectResource();
            currencyRes.$save({}, //no params
                function (data) {
                    try{
                        currency.setId(data.id);
                        if (successFunction !== undefined)
                            successFunction(data);
                    }
                    finally {
                        ServerSrv.endSavingProcess(true);
                    }
                },
                function (data) {   //failure
                    //error handling goes here
                    try{
                        if (errorFunction !== undefined)
                            errorFunction(data);
                    }
                    finally {
                        ServerSrv.endSavingProcess(false,(data?data.status:null),(data && data.data?data.data.errorCode:null));
                    }
                }
            );

            //},2000)
        };
        currencySrv.remove = function(currency,successFunction,errorFunction)
        {
            CurrencyData.remove(currency);
            ServerSrv.startSavingProcess(currencySrv.removeSync, currency, successFunction, errorFunction);
        };
       
        currencySrv.removeSync = function(currency,successFunction,errorFunction)
        {
            //$timeout (function () {

            var currencyRes = currency.getObjectResource();
            currencyRes.$remove({id:currency.getId()}, //no params
                function (data) {
                    try{
                        if (successFunction !== undefined)
                            successFunction(data);
                    }
                    finally {
                        ServerSrv.endSavingProcess(true);
                    }
                },
                function (data) {
                    //error handling goes here
                    try{
                        if (errorFunction !== undefined)
                            errorFunction(data);
                    }
                    finally {
                        ServerSrv.endSavingProcess(false,(data?data.status:null),(data && data.data?data.data.errorCode:null));
                    }
                }
            );

            //},2000)
        };

        return currencySrv;
    }
]);


angular.module('FlexyBeautyApp.services').
factory('CurrencyData', ["$log",
    function($log) {
        var currencyData = {
            indexCountries : [], //Used as Index
            activeCountries : [],
            deletedCountries : []
        };

        currencyData.getBycode = function(currencyCode) {
            for (var i=0;i<this.indexCountries.length;i++)
                if (this.indexCountries[i].code==currencyCode)
                    return this.indexCountries[i];
            return null;
        }

        currencyData.getByIndex = function(servIndex) {
            if (servIndex >= 0 && servIndex < this.indexCountries.length) {
                return this.indexCountries[servIndex];
            }
            return null;
        }

        currencyData.getById = function(currencyId) {
            for (var i=0;i<this.indexCountries.length;i++)
                if (this.indexCountries[i].id==currencyId)
                    return this.indexCountries[i];
            return null;
            return null;
        }

        currencyData.getIndexOf = function(currency) {
            if (currency)
                return this.indexCountries.indexOf(currency);
            return -1;
        }

        currencyData.add = function(currency) {
            var currencyArray = this.activeCountries;
            if (currency.isDeleted)
                currencyArray =  this.deletedCountries;
            var index =  this.indexCountries.indexOf(currency);
            if (index!=-1)
            {
                var realIndex = currencyArray.indexOf(currency);
                if (realIndex==-1)
                    currencyArray.push(currency);
            }
            else
            {
                index = this.indexCountries.length
                this.indexCountries.push(currency);
                currencyArray.push(currency);
            }
            return index;
        }

        //Soft Remove
        currencyData.remove = function(currency) {
            var index =  this.activeCountries.indexOf(currency);
            if (index!=-1)
            {
                this.activeCountries.splice(index, 1);
                this.deletedCountries.push(currency)
                currency.isDeleted=true;
            }
        }

        //Soft Remove
        currencyData.restore = function(currency) {
            var index =  this.deletedCountries.indexOf(currency);
            if (index!=-1)
            {
                this.deletedCountries.splice(index, 1);
                this.activeCountries.push(currency);
                currency.isDeleted=false;
            }
        }
        currencyData.getActiveList =  function()
        {
            return this.activeCountries;
        }

        currencyData.clear = function() {
            currencyData.indexCountries = [];
            currencyData.activeCountries = [];
            currencyData.deletedCountries = [];
        }

        currencyData.getDeletedList = function() {
            return currencyData.deletedCountries;
        }
        return currencyData;
    }
]);



// WEBPACK FOOTER //
// ./js/services/models/Currency.js